<template>
  <button
    :class="`text-bold float-right rounded-full bg-blue-900 text-white ${customPadding}`"
    type="button"
    @click="navigateToGenerateReportsPage"
  >
    Generate Report
  </button>
</template>

<script>
export default {
  name: 'GenerateReportsButton',

  props: {
    reportId: {
      type: Number,
      required: true,
    },
    customPadding: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      tierCanGenerateReports: false,
    }
  },

  async mounted() {
    this.tierCanGenerateReports
      = await this.$apis.tiers.checkLimit('disclosure_reports')
  },

  methods: {
    navigateToGenerateReportsPage() {
      this.$router.push(
        this.tierCanGenerateReports
          ? `/reports/generate/${this.reportId}`
          : { name: 'errors-ErrorPermission' },
      )
    },
  },
}
</script>
